import type { IStudio } from '../../../screens/Dashboard/SubComponents/Studio/interfaces/Studio.interface';
import { TemplateType } from '../../../screens/Dashboard/SubComponents/Studio/interfaces/sub-interfaces/Template.interface';

const PictureInPicture: IStudio = {
  id: '0',
  version: '0.1.0',
  type: TemplateType.Six,
  output: {
    quality: {
      audio: 1,
      video: 1,
    },
    sizes: {
      height: 1080,
      width: 1920,
    },
  },
  areas: [
    {
      id: 'area-1',
      label: 'area 1',
      bounds: {
        width: 100,
        height: 100,
        top: 0,
        left: 0,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },
    {
      id: 'area-2',
      label: 'area 2',
      bounds: {
        width: 15,
        height: 18.4,
        top: 76.6,
        left: 80,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },
  ],
};

export default PictureInPicture;
